import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LEGAL_DOCUMENT_PATHS } from '@/constants/legal';
import { cn } from '@/lib/utils';

interface LegalLinksProps {
  className?: string;
}

export function LegalLinks({ className }: LegalLinksProps) {
  const { t } = useTranslation('legal');
  return (
    <nav
      aria-label={t('linksLabel')}
      className={cn(
        'flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-zoomuted',
        className
      )}
    >
      <Link to={LEGAL_DOCUMENT_PATHS.privacy_notice} className="hover:text-zooindigo underline">
        {t('privacyNotice')}
      </Link>
      <Link to={LEGAL_DOCUMENT_PATHS.terms_of_service} className="hover:text-zooindigo underline">
        {t('termsOfService')}
      </Link>
      <Link
        to={LEGAL_DOCUMENT_PATHS.data_processing_agreement}
        className="hover:text-zooindigo underline"
      >
        {t('dataProcessingAgreement')}
      </Link>
      <Link
        to={LEGAL_DOCUMENT_PATHS.client_portal_terms}
        className="hover:text-zooindigo underline"
      >
        {t('clientPortalTerms')}
      </Link>
    </nav>
  );
}
